import s from './BlogDetail2.module.scss';
import SubHeader from '../../components/SubHeader/SubHeader';
import { Aside } from '../../components/Aside/Aside';
import { Helmet } from 'react-helmet-async';

const breadcrumbs = [
  { label: 'ホーム ', link: '/' },
  { label: 'ジェイさんブログ', link: '/blog' },
  { label: 'ジェイさんマガジン', link: '/blog/magazine' },
  { label: '大自然動物探検ツアー ジェイさんツアーマガジン#02'}
];

const BlogDetail2 = () => {
  return (
    <>
              <Helmet>
        <title>大自然動物探検ツアー ジェイさんツアーマガジン#02</title>
        <meta property="og:title" content="大自然動物探検ツアー ジェイさんツアーマガジン#02" />
        <meta property="og:image" content="https://dev.mightyaussie.com/wp-content/uploads/2019/12/ANML_01_thum-1140x530.png" />
        <meta property="og:url" content={`${process.env.REACT_APP_URL}/blog/magazine/num02`} />
        <meta name="description" content="自社ツアーやオプショナルツアーも予約できます！" />
        <meta property="og:description" content="自社ツアーやオプショナルツアーも予約できます！" />
        <meta property="og:type" content="article" />

      </Helmet>
    <div className={s.root}>
           <SubHeader
      title="大自然動物探検ツアー ジェイさんツアーマガジン#02"
      breadcrumbs={breadcrumbs}
    />
    <div className={s.flex}>
    <div className={s.width}>
      <div className={s.cardContent}>
        <h2 className={s.cardTitle}>大自然動物探検ツアー ジェイさんツアーマガジン#02</h2>
        <ul className={s.article}>
          <li>
            <i class="fa fa-calendar"></i><a href="https://dev.mightyaussie.com/blog/magazine/num01"><time itemprop="datePublished" class="entry-date published" datetime="2019-12-13T10:42:20+09:00">2023年11月21日</time></a>
          </li>
          <li><i class="fa fa-user"></i><span itemprop="author" itemscope="" itemtype="https://schema.org/Person" class="vcard author"><span class="fn" itemprop="name">ジェイさんツアー</span></span></li>
          <li><i class="fa fa-pencil"></i><span itemprop="articleSection"><a href="https://dev.mightyaussie.com/category/blog/magazine">ジェイさんマガジン</a></span></li>
        </ul>
      </div>
      <img src="https://dev.mightyaussie.com/wp-content/uploads/2019/12/ANML_01_thum-1140x530.png" alt="" />
      <h2>大自然動物探検ツアー</h2>
      <p>大人も子供も大満足✨<br/>
動物園では見られない野生のワラビーや夜行性動物との触れ合い</p>
<img src="https://dev.mightyaussie.com/wp-content/uploads/2019/12/ANML_02.png" alt="" />
<h2>午前中のグリーン島やキュランダ観光と組み合わせ可能</h2>
<p>13時ごろにケアンズを出発するツアーなので、午前中に他のツアーにさんかしたり、ケアンズ市内でのんびりした午前中を過ごすなど自由に過ごすことができます。13時からのツアーは20時ごろには食事、星空観察も終えるので、小さなお子様のいる三世代家族にも大人気。盛り沢山な内容から大人の遠足としてグループ旅行でも最も選ばれるツアーです。</p>
<img src="https://dev.mightyaussie.com/wp-content/uploads/2019/12/ANML_04-819x1024.png" alt="" />
<h2>ちいさなアリが作り出す巨大なアリ塚</h2>
<p>巨大なアリ塚の不思議をガイドから教えてもらおう！キュランダの熱帯雨林を越えてユーカリが生い茂る乾燥地に変わると所々に岩のようなものが…<br/>
実はこれ、長年の歳月をかけて作られたアリ塚なんです。</p>
<img src="https://dev.mightyaussie.com/wp-content/uploads/2019/12/ANML_05-819x1024.png" alt="" />
<h2>動物探検ツアー一押し！野生ロックワラビーの餌やり体験</h2>
<p>笑顔で餌を食べるワラビーを見ると、大人も子供も自然と笑顔に。他社と違ってこのスポットの滞在時間が長いため、ワラビーと触れ合うことができる時間が長く、素敵な写真がたくさん撮れます！ワラビー以外にもたくさんの動物がいるので探してみよう。<br/>
実は、周辺の景色も絶景なので見逃さないでね！</p>
<img src="https://dev.mightyaussie.com/wp-content/uploads/2019/12/ANML_03-819x1024.png" alt="" />
<h2>動物園でもなかなかみられないカモノハシの探索！</h2>
<p>１億５千年前の哺乳類の末裔。大きな進化をせず、太古のままの生態を保ったとても貴重な生物です。<br/>
目の見えないカモノハシはとても音に敏感です。探索するときは足音に注意してね。一般の方も探しに来ているので、どんなふうに探しているのか見てみても面白いですよ。ジェイさんツアーはカモノハシの探索時間をしっかり設けているので、遭遇率がとても高いんです！</p>
<img src="https://dev.mightyaussie.com/wp-content/uploads/2019/12/ANML_07.png" alt="" />
<h2>神秘の樹カーテンフィグツリー</h2>
<p>樹齢、約500年のカーテンフィグツリー。絞め殺しのイチジクとも呼ばれ進歩的な雰囲気が漂っています。</p>
<img src="https://dev.mightyaussie.com/wp-content/uploads/2019/12/ANML_08.png" alt="" />
<h2>貸し切りの広大な牧場での楽しい体験</h2>
<p>ブーメラン体験やポニーとの触れ合いで盛り上がります！野生動物や可愛いポニーがいる広大な牧場で、ブーメラン投げをしよう！ブーメラン投げ体験は意外と大人の方が楽しんでいます。アボリジニ文化に触れる貴重な体験です。(ブーメラン投げができるのはジェイさんツアーだけ！)</p>
<img src="https://dev.mightyaussie.com/wp-content/uploads/2019/12/ANML_09-819x1024.png" alt="" />
<h2>夕食は本場のオージービーフを使ったBBQ！</h2>
<p>アットホームな牧場でオージーBBQにオーストラリアの家庭の味のサラダ、ワイン、ジュースも飲み放題！人懐っこいポッサムなどの夜行性動物も近くによってきます！</p>
<img src="https://dev.mightyaussie.com/wp-content/uploads/2019/12/ANML_06-819x1024.png" alt="" />
<h2>光を遮るものは何もない、南半球の圧倒的な星空</h2>
<p>皆さん、天の川は見たことありますか？標高700Mから見る夜空にはプラネタリウムよりも圧倒的な息を呑むほどの星空が広がっています。南半球でしか見ることができない南十字星（2月〜10月上旬まで）や織姫星・彦星・夏の大三角形・冬の大三角系など、神話の世界が目の前に広がります！<br/>
運が良ければ、多い時で１分に１個くらいの流れ星が見えることもあります。さらに、雨季の時期には蛍の乱舞を見ることができますよ。</p>
<img className={s.follow} src="https://dev.mightyaussie.com/wp-content/uploads/2019/12/ANML_10-819x1024.png" alt="" />
<div className={s.tour}>
  <img src="	https://dev.mightyaussie.com/wp-content/uploads/2019/05/anml33-600x450.jpg" alt="" />

  <div class="wpb_wrapper">
			<h3>その他の動物探検ができるツアーはこちら</h3>
      <p>このツアーの他にも、ケアンズの大自然を満喫できる動物探検ツアーがたくさんあります。野生のロックワラビーやポッサム、エリマキトガケ、カモノハシ探索、ポニーとの触れ合い、野生の木登りカンガルー散策などなど盛りだくさん！<br/>
      動物園でみるより野生動物を自分たちで探して見るほうが、何倍もテンションが上がって楽しいですよ☆</p>
<div class="vc_btn3-container vc_btn3-left"><a className={s.link} href="/all-tours?tags=動物" title="">ケアンズ動物探検に関するツアーを見る</a></div>
  </div>

</div>
    </div>
    <Aside/>
    </div>
    </div>
    </>
  );
};

export default BlogDetail2;
